function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2461:68500)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M79 30.9083V36.7291L39.5 65.4149L39.483 65.4268L0 36.7291V30.9083L10.9319 22.7363H68.0681L79 30.9083Z",
  fill: "#2C398B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79 30.9083V36.7291L39.5 65.4149V22.7363H68.0681L79 30.9083Z",
  fill: "#2C398B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.9707 0V44.9396L39.5185 63.876L39.5 63.864L10.0293 44.9337V0L68.9707 0Z",
  fill: "#D1EAE7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.9707 0V44.9396L39.5185 63.876L39.5 63.864V0L68.9707 0Z",
  fill: "#D1EAE7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79 41.2288V77.0009H0V36.7305L39.483 60.93L39.5185 60.9524L79 41.2288Z",
  fill: "#F15A23"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.9994 36.7305V77.0009H39.4824V60.93L39.5179 60.9524L78.9994 36.7305Z",
  fill: "#F15A23"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.4997 48.3873C50.2863 48.3873 59.0305 39.8644 59.0305 29.3509C59.0305 18.8374 50.2863 10.3145 39.4997 10.3145C28.713 10.3145 19.9688 18.8374 19.9688 29.3509C19.9688 39.8644 28.713 48.3873 39.4997 48.3873Z",
  fill: "#0D777D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.0309 29.3509C59.0309 39.8482 50.2699 48.3873 39.5 48.3873V10.3145C50.2699 10.3145 59.0309 18.8536 59.0309 29.3509Z",
  fill: "#0D777D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.2492 26.0023L37.4901 36.489L30.752 29.9215L34.0246 26.7317L37.4901 30.1095L39.5006 28.1499L44.9766 22.8125L48.2492 26.0023Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.2486 26.0023L39.5 34.5294V28.1499L44.976 22.8125L48.2486 26.0023Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2461:68500"
}, /*#__PURE__*/React.createElement("rect", {
  width: 79,
  height: 77,
  fill: "white"
})));

function SvgMailSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 77,
    viewBox: "0 0 79 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSuccess);
export default __webpack_public_path__ + "static/media/mail-success.462afdaf.svg";
export { ForwardRef as ReactComponent };